import { router } from 'expo-router';
import { isWeb } from 'shared/constants/platform';

export enum Tabs {
  HOME = '/(authenticated)/(tabs)',
  MOVE_MONEY = '/(authenticated)/(tabs)/move-money',
  CASHBACK = '/(authenticated)/(tabs)/rewards',
  MY_VARO = '/(authenticated)/(tabs)/myvaro',
}
/**
 * dismisses back to entry for (tabs) in the nav stack or navigates to
 * (tabs) if the (tabs) is not in the nav stack.
 *
 * this is different than navigate('/(tabs)') because it will preserve the
 * selected tab.
 */
const useDismissToRootTab = () => {
  const dismissToTab = (tab: Tabs) => {
    if (isWeb) {
      router.dismissAll();
      router.navigate(tab);
    } else {
      router.dismissTo(tab);
    }
  };

  return dismissToTab;
};

export default useDismissToRootTab;
